import React from "react"
import { graphql } from "gatsby"
import { HelmetDatoCms } from "gatsby-source-datocms"

import Hero from "./Hero"

import Layout from "../../components/Layout"
import Content from "../../components/Content"

const SITE_URL = "https://gadait-international.com"

const Index = ({ data }) => {
  const enVersion = data.page._allSlugLocales.find(version => version.locale === "en")
  const xDefaultHref = enVersion
    ? `${SITE_URL}/en/${enVersion.value}/`
    : `${SITE_URL}/en/${data.page.slug}/`

  const pageAlternates = data.page._allSlugLocales.map(version => ({
    rel: "alternate",
    hreflang: version.locale,
    href: `${SITE_URL}/${version.locale}/${version.value}/`,
  }))

  return (
    <Layout
      transparentHeader
      locale={data.page.locale}
      // Static href of the language switch (FR/EN slugs differ).
      alternates={pageAlternates}
    >
      <HelmetDatoCms
        htmlAttributes={{
          lang: data.page.locale,
        }}
        seo={data.page.seoMetaTags}
      >
        {/* Explicit canonical: the canonical-urls plugin uses the page path,
            which has no trailing slash and 301s on Netlify. */}
        <link
          rel="canonical"
          href={`${SITE_URL}/${data.page.locale}/${data.page.slug}/`}
        />
        {data.page._allSlugLocales.map((version, index) => (
          <link
            rel="alternate"
            hreflang={version.locale}
            href={`${SITE_URL}/${version.locale}/${version.value}/`}
            key={index}
          />
        ))}
        <link rel="alternate" hreflang="x-default" href={xDefaultHref} />
      </HelmetDatoCms>

      <div className="page">
        <Hero data={data.page} />
        <Content content={data.page.content} />
      </div>
    </Layout>
  )
}

export const query = graphql`
  query PageQuery($locale: String!, $slug: String!) {
    page: datoCmsPage(locale: { eq: $locale }, slug: { eq: $slug }) {
      ...Page
    }
  }
`

export default Index
